// extracted by mini-css-extract-plugin
module.exports = {"inviteFriend":"InviteFriend_inviteFriend__1tss7","formWrapper":"InviteFriend_formWrapper__39Git","close":"InviteFriend_close__23Igi"};